import React from 'react'
// c:\xampp\htdocs\miners-market-main\components\AccountDeletionModal.js

export default function AccountDeletionModal({ isOpen, onClose, onConfirm, user }) {
    const [reason, setReason] = React.useState('');
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [success, setSuccess] = React.useState(null);

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!reason.trim()) {
            setError('A reason for deletion is required.');
            return;
        }
        setIsSubmitting(true);
        setError(null);
        setSuccess(null);

        try {
            const result = await onConfirm(reason);
            setSuccess(result.message);
            setTimeout(() => {
                onClose();
                setSuccess(null);
                setReason('');
            }, 3000);
        } catch (err) {
            setError(err.message);
            setIsSubmitting(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[101] p-4">
            <div className="bg-white rounded-xl p-8 max-w-lg w-full">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-bold text-gray-900">Request Account Deletion</h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600 disabled:opacity-50" disabled={isSubmitting}>
                        <i className="fas fa-times text-xl"></i>
                    </button>
                </div>
                <p className="text-gray-600 mb-4">
                    You are requesting to delete the account for <strong>{user.name}</strong> ({user.email}). This action is not immediate and will be processed by an administrator. Please provide a reason for your request.
                </p>
                
                {error && <div className="bg-red-100 text-red-700 p-3 rounded-lg text-sm mb-4">{error}</div>}
                {success && <div className="bg-green-100 text-green-700 p-3 rounded-lg text-sm mb-4">{success}</div>}

                <form onSubmit={handleSubmit}>
                    <textarea
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder="Please provide a reason for your deletion request..."
                        rows="5"
                        className="w-full p-2 border border-gray-300 rounded-md shadow-sm"
                        disabled={isSubmitting}
                        required
                    ></textarea>

                    <div className="flex justify-end mt-6 space-x-4">
                        <button type="button" onClick={onClose} disabled={isSubmitting} className="bg-gray-200 text-gray-800 py-2 px-4 rounded-lg hover:bg-gray-300 disabled:opacity-50">
                            Cancel
                        </button>
                        <button 
                            type="submit" 
                            disabled={isSubmitting} 
                            className="bg-red-600 text-white py-2 px-4 rounded-lg hover:bg-red-700 disabled:opacity-50"
                        >
                            {isSubmitting ? 'Submitting...' : 'Confirm Deletion Request'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}


